import { render, staticRenderFns } from "./ProjectBoard.vue?vue&type=template&id=8c6e2598"
import script from "./ProjectBoard.vue?vue&type=script&lang=ts"
export * from "./ProjectBoard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports